module.exports = __webpack_public_path__ + "static/media/184.e11b7a3c.jpg";